/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "%future added value" | "%future added value" | "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbRespRefineMenu_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly pageType: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespAppliedFilters_itemSearch" | "SbSharedRefineMenuFilters_itemSearch" | "SbSharedRefineMenuDisplayPrefsSelect_itemSearch">;
    readonly " $refType": "SbRespRefineMenu_itemSearch";
};
export type SbRespRefineMenu_itemSearch$data = SbRespRefineMenu_itemSearch;
export type SbRespRefineMenu_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenu_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenu_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '9a44aba6b099ca35b03861e4b3ef362e';
export default node;
